import { useMemo } from 'react'
import { Field, FieldProps, FieldRenderProps, FormSpy } from 'react-final-form'
import TimeField from 'components/ui/TimeField'
import isString from 'lodash/isString'
import isDate from 'lodash/isDate'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_FIELD_PROPS: Partial<FieldProps<any, any>> = {}

type TimeFieldProps = {
  label?: string
  description?: string
  placeholder?: string
  newDesign?: boolean
}

export type Props = TimeFieldProps & {
  name: string
  baseDate: Date | string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: Partial<FieldProps<any, any>>
}

function InnerField({
  input,
  label,
  description,
  baseDate,
  newDesign,
  meta: { touched, error: syncError, submitError, submitting }
}: FieldRenderProps<Date, HTMLInputElement> & TimeFieldProps) {
  const error = syncError || submitError
  const showError = (touched || submitError) && !!error
  const timeFieldProps = {
    disabled: submitting,
    error: showError ? error : null,
    description,
    label,
    ...input
  }
  const now = useMemo(() => new Date(), [])

  if (isString(baseDate)) {
    return (
      <FormSpy subscription={{ values: true }}>
        {({ values }) => {
          const baseDateValue: Date = values[baseDate] || now
          if (!baseDateValue || !isDate(baseDateValue)) {
            throw new Error(
              `No base date under '${baseDate}' key: ${baseDateValue}`
            )
          }
          return (
            <TimeField
              baseDate={baseDateValue}
              {...timeFieldProps}
              newDesign={newDesign}
            />
          )
        }}
      </FormSpy>
    )
  }

  return <TimeField baseDate={baseDate} {...timeFieldProps} />
}

export default function FormTimeField({
  name,
  fieldProps = EMPTY_FIELD_PROPS,
  ...innerProps
}: Props) {
  return (
    <Field<Date, FieldRenderProps<Date, HTMLInputElement>, HTMLInputElement>
      name={name}
      render={(props) => <InnerField {...props} {...innerProps} name={name} />}
      {...fieldProps}
    />
  )
}
